// Display labels for the fixed-vocabulary tag categories. VZ tags fall back
// to a dashes-to-spaces rendering of the slug since the original VZ name
// isn't carried on the tag itself (see /dealers/tag-options for that).
export const SERVICE_TAG_LABELS = {
  Sales: "Sales",
  UsedCarSales: "Used Car Sales",
  SalesOthers: "Other Sales",
  Service: "Service",
  Others2Service: "Other Service",
  HeavyCrashPartners: "Accident Specialist",
};

export const CERT_TAG_LABELS = {
  PartnerPlusOne: "1+ Partner",
  WeltAuto: "Welt Auto",
  SkodaPlus: "Skoda Plus",
  CertifiedSeller: "Certified Seller",
  FinancialCertified: "Financial Certified",
  SkodaClub: "Skoda Club",
};

export const CONTRACT_TAG_LABELS = {
  IsSales: "Sales",
  IsService: "Service",
};

const CATEGORY_STYLES = {
  Contract: "border-blue-500/40 bg-blue-500/10 text-blue-700 dark:text-blue-400",
  Services: "border-border bg-secondary text-muted-foreground",
  Cert: "border-emerald-500/40 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400",
  VZ: "border-violet-500/40 bg-violet-500/10 text-violet-700 dark:text-violet-400",
};

export function dealerTagLabel(tag) {
  const dot = tag.indexOf(".");
  const category = dot === -1 ? tag : tag.slice(0, dot);
  const suffix = dot === -1 ? "" : tag.slice(dot + 1);
  if (category === "Contract") return CONTRACT_TAG_LABELS[suffix] || suffix;
  if (category === "Services") return SERVICE_TAG_LABELS[suffix] || suffix;
  if (category === "Cert") return CERT_TAG_LABELS[suffix] || suffix;
  if (category === "VZ") return suffix.replace(/-/g, " ");
  return tag;
}

/** Category color classes for a tag (e.g. "Cert.WeltAuto" -> the emerald
 * chip styling) — shared between the tag chip display and the tag filter
 * dropdown so the color coding stays consistent everywhere. */
export function dealerTagCategoryClassName(tag) {
  const category = tag.split(".")[0];
  return CATEGORY_STYLES[category] || "border-border bg-secondary text-muted-foreground";
}

/** Small chip row for a dealer's computed tags (Contract/Services/Cert/VZ) —
 * used on both the dealer list and the dealer detail header. */
export function DealerTagBadges({ tags = [], className = "" }) {
  if (!tags.length) return null;
  return (
    <div className={`flex flex-wrap gap-1 ${className}`}>
      {tags.map((tag) => (
        <span
          key={tag}
          title={tag}
          className={`rounded-full border px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider ${dealerTagCategoryClassName(tag)}`}
        >
          {dealerTagLabel(tag)}
        </span>
      ))}
    </div>
  );
}
